import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import clsx from 'clsx';

const generateBreadcrumbItems = (location, routes) => {
    const pathElements = location.pathname.split('/').filter((path) => path);
    let pathAccumulator = '';
    let breadcrumbItems = [];
    let params = {};

    pathElements.forEach((pathElement, index) => {
        pathAccumulator += `/${pathElement}`;
        const route = routes.find((r) => new RegExp(`^${r.path.replace(/:[^\s/]+/g, '[^/]+')}$`).test(pathAccumulator));

        if (route) {
            const paramNames = (route.path.match(/:[^\s/]+/g) || []).map(param => param.substring(1));
            paramNames.forEach((paramName, i) => {
                params[paramName] = pathElements[index - paramNames.length + i + 1];
            });

            if (route.breadcrumb && route.breadcrumb.length > 0) {
                route.breadcrumb.forEach((breadcrumb) => {
                    if (!breadcrumbItems.find(item => item.label === breadcrumb.label)) {
                        let url = breadcrumb.url || pathAccumulator;
                        Object.keys(params).forEach(param => {
                            url = url.replace(`:${param}`, params[param]);
                        });
                        breadcrumbItems.push({ label: breadcrumb.label, url });
                    }
                });
            }
        }
    });
    return breadcrumbItems;
};

const DynamicBreadcrumb = ({ routes }) => {
    const history = useHistory();
    const location = useLocation();
    const breadcrumbItems = generateBreadcrumbItems(location, routes);

    // TODO: Decide weather to keep this or not.
    // if (breadcrumbItems.length <= 1) return null;
    if (breadcrumbItems?.length <= 0) return null;

    return (
        <nav className="breadcrumb container" aria-label="breadcrumbs">
            <ul>
                {breadcrumbItems.map((item, index) => (
                    <li key={index} className={clsx({ 'is-zero-opacity': breadcrumbItems?.length === 1 })}>
                        <a href={item.url} onClick={(event) => {
                            event.preventDefault();
                            history.push(item.url);
                        }}>{item.label}</a>
                    </li>
                ))}
            </ul>
        </nav>
    );
};

export default DynamicBreadcrumb;